import { useState, useEffect } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../../config/firebase';
import { useAuth } from '../../../hooks/useAuth';

export default function PESTELFramework({ dealId }) {
  const { user, userProfile } = useAuth();
  const [analysis, setAnalysis] = useState('');
  const [saving, setSaving] = useState(false);
  const [saveMsg, setSaveMsg] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDoc(doc(db, 'deals', dealId, 'frameworks', 'pestel'))
      .then((snap) => {
        if (snap.exists()) {
          setAnalysis(snap.data().analysis || '');
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [dealId]);

  async function handleSave() {
    setSaving(true);
    setSaveMsg('');
    try {
      await setDoc(doc(db, 'deals', dealId, 'frameworks', 'pestel'), {
        completed_by: user?.uid || '',
        completed_by_name: userProfile?.full_name || userProfile?.display_name || '',
        completed_at: new Date().toISOString(),
        analysis,
      });
      setSaveMsg('Saved successfully');
    } catch (err) {
      setSaveMsg('Save failed: ' + (err.message || 'Unknown error'));
    } finally {
      setSaving(false);
    }
  }

  if (loading) {
    return <div style={{ padding: 16, color: 'var(--color-text-secondary)', fontSize: 13 }}>Loading...</div>;
  }

  return (
    <div>
      <p style={{ fontSize: 13, color: 'var(--color-text-secondary)', marginBottom: 20, lineHeight: 1.6 }}>
        Provide a narrative PESTEL analysis covering all six dimensions: Political, Economic,
        Social, Technological, Environmental, and Legal factors affecting this company and its market.
      </p>

      <div className="form-field" style={{ marginBottom: 24 }}>
        <label className="form-label">PESTEL Analysis</label>
        <textarea
          className="form-textarea"
          value={analysis}
          onChange={(e) => setAnalysis(e.target.value)}
          placeholder="Provide a narrative analysis covering Political, Economic, Social, Technological, Environmental and Legal factors affecting this company and its market..."
          rows={12}
        />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <button
          onClick={handleSave}
          disabled={saving}
          style={{
            padding: '8px 20px',
            borderRadius: 6,
            border: '1px solid var(--color-accent)',
            background: 'var(--color-accent)',
            color: '#fff',
            cursor: saving ? 'not-allowed' : 'pointer',
            fontSize: 13,
            fontWeight: 600,
            opacity: saving ? 0.7 : 1,
          }}
        >
          {saving ? 'Saving...' : 'Save Framework'}
        </button>
        {saveMsg && (
          <span style={{
            fontSize: 13,
            color: saveMsg.includes('failed') ? 'var(--color-error)' : 'var(--color-success)',
          }}>
            {saveMsg}
          </span>
        )}
      </div>
    </div>
  );
}
